import PropTypes from 'prop-types';
import React from 'react';
import PureComponent from '../../pure';
import Select from '../../formElements/Select';
import InputText from '../../formElements/InputText';
import ReportWindowColumn from './ReportWindowColumn';
import sAction from 'sAction';

class ReportWindowColumnsContainer extends PureComponent {
    constructor(props) {
        super();
        this.state = {
            searchValue: null,
            lockedColumns: sAction.dataGet(props.prefix + '/metadata/lockedColumns'),
            lockedColumnsNames: [],
        };
        this.searchInput = React.createRef();
    }
    searchChange() {
        const inputValue = this.searchInput.current.value;
        this.setState({
            searchValue: inputValue.toLowerCase(),
        });
    }

    changeSelected(moduleName) {
        const relatePole = sAction.dataGet('reportWindow/activeRelate').toJS();
        if (relatePole) {
            for (const [key, value] of Object.entries(relatePole)) {
                if (key.toLowerCase() === moduleName.toLowerCase()) {
                    value.selected = true;
                    continue;
                }
                value.selected = false;
            }
            sAction.dataSet('reportWindow/activeRelate', relatePole);
        }
    }

    setLock(name, locked) {
        let newLockedColumns = this.state.lockedColumns;
        let data = this.props.data;

        if (locked) {
            this.state.lockedColumnsNames.push(name);
            newLockedColumns = this.state.lockedColumns + 1;
            this.setState({
                lockedColumnsNames: this.state.lockedColumnsNames,
                lockedColumns: newLockedColumns,
            });
        } else {
            const lockedColumnsNames = this.state.lockedColumnsNames.filter((item) => item !== name);
            newLockedColumns = this.state.lockedColumns - 1;
            this.setState({
                lockedColumnsNames: lockedColumnsNames,
                lockedColumns: newLockedColumns,
            });
        }

        // sort data so that locked columns are first
        const lockedColumnsNames = this.state.lockedColumnsNames;
        if (lockedColumnsNames.length > 0) {
            // filter out locked columns
            const lockedColumns = data.filter((column) => {
                return lockedColumnsNames.includes(column.name);
            });

            // filter out unlocked columns
            const unlockedColumns = data.filter((column) => {
                return !lockedColumnsNames.includes(column.name);
            });

            data = lockedColumns.concat(unlockedColumns);

            // save changes to store
            sAction.dataSet(this.props.prefix + '/columns/active', data);
        }

        // save changes to store
        sAction.dataSet(this.props.prefix + '/metadata/lockedColumns', newLockedColumns);
    }

    render() {
        const data = this.props.data;
        const customClass = this.props.customClass;
        const setWidth = this.props.setWidth;
        const setOrder = this.props.setOrder;
        const prefix = this.props.prefix;
        const allowLock = this.props.allowLock;
        let active = false;
        const columnsRender = [];
        let countLocked = 0;

        data.forEach((column, index) => {
            let locked = false;
            if (column.def != undefined) {
                if (allowLock && this.state.lockedColumns && countLocked < this.state.lockedColumns) {
                    if (this.state.lockedColumnsNames.length < this.state.lockedColumns) {
                        this.state.lockedColumnsNames.push(column.def.get('name'));
                    }
                    locked = true;
                    countLocked++;
                }

                let vname = sAction.translate(
                    column.def.get('vname'),
                    column.def.get('fieldModule'),
                );

                if (vname) {
                    vname = vname.replace(':', '');
                    let add = true;
                    if (
                        this.state.searchValue != null &&
                        vname.toLowerCase().indexOf(this.state.searchValue) == -1
                    ) {
                        add = false;
                    }

                    if (this.props.modulName == true) {
                        active = true;
                        vname = (
                            <>
                                <div
                                    className="reportWindowSelectFields names"
                                    data-way="first"
                                >
                                    {vname}
                                </div>
                                <div className="reportWindowSelectFields">
                                    {sAction.app_strings.moduleList[
                                        column.def.get('fieldModule')
                                    ] + ' | '}
                                    {column.name +
                    ' | ' +
                    sAction.findTypeTranslation(column.def.get('type'))}
                                </div>
                            </>
                        );
                    } else {
                        vname = [
                            <div
                                className="reportWindowSelectFields first"
                                key="first"
                                data-way="first"
                            >
                                {vname}
                            </div>,
                            <div className="reportWindowSelectFields" key="second">
                                {column.name +
                  ' | ' +
                  sAction.findTypeTranslation(column.def.get('type'))}
                            </div>,
                        ];
                    }

                    if (this.props.notAllowedTypes !== undefined) {
                        const type = column.def.get('type');
                        if (this.props.notAllowedTypes.includes(type)) {
                            add = false;
                        }
                        if (column.def.get('group') != undefined) {
                            add = false;
                        }
                        if (column.def.get('dbType') == 'id') {
                            add = false;
                        }
                    }

                    if (add == true) {
                        columnsRender.push(
                            <ReportWindowColumn
                                key={index + column.name}
                                index={this.props.containerName + '/' + index}
                                module={data.module}
                                vname={vname}
                                data={column}
                                setWidth={setWidth}
                                allowLock={allowLock}
                                setOrder={setOrder}
                                prefix={prefix}
                                locked={locked}
                                setLock={(index, locked) => this.setLock(index, locked)}
                            />,
                        );
                    }
                }
            }
        });

        // serazeni hidden sloupcu podle abecedy
        if (!active) {
            columnsRender.sort((a, b) =>
                a.props.vname[0].props.children.localeCompare(
                    b.props.vname[0].props.children,
                ),
            );
        }

        columnsRender.push(
            <div
                className="reportWindowColumn"
                style={{border: 'none'}}
                key="last"
                data-way="last"
            ></div>,
        );

        let modulPanel = null;
        let defaultSelectValue = null;
        if (this.props.withModuleSelect == true) {
            const relate = this.props.activeRelate;
            const options = [];
            relate.forEach((modul, key) => {
                if (modul.get('selected')) {
                    defaultSelectValue = key;
                }

                options.push({
                    value: key,
                    label: sAction.app_strings.moduleList[modul.get('module')],
                });
            });
            modulPanel = (
                <div className="reportWindowModulListContainer">
                    <div className="moduleList">
                        <span>{sAction.translate('LBL_REPORT_MODULE')}{'\u00A0'}</span>
                        <Select
                            defaultValue={defaultSelectValue}
                            containerClassName="withBorder"
                            onChange={(e) => {
                                sAction.reportWindowColumnsModule(e.target.value);
                                this.changeSelected(e.target.value);
                            }}
                            options={options}
                        />
                    </div>
                    <div className="moduleSearch">
                        <InputText
                            myRef={this.searchInput}
                            onKeyUp={() => this.searchChange()}
                            className="withBorder"
                            placeholder={sAction.translate('LBL_REPORT_SEARCH_FOR')}
                        />
                    </div>
                </div>
            );
        }
        return (
            <div className={customClass}>
                {modulPanel}
                {setWidth && (
                    <div className="reportWindowColumnWidthHeader">
                        <div></div>
                        <div>Šířka [%]</div>
                    </div>
                )}
                <div
                    className={this.props.moveClass}
                    data-holderclassname="reportWindowColumns"
                    data-way={this.props.containerName}
                >
                    {columnsRender}
                </div>
            </div>
        );
    }
}

ReportWindowColumnsContainer.propTypes = {
    activeRelate: PropTypes.any,
    containerName: PropTypes.string,
    customClass: PropTypes.any,
    data: PropTypes.any,
    modulName: PropTypes.bool,
    moveClass: PropTypes.any,
    notAllowedTypes: PropTypes.any,
    prefix: PropTypes.any,
    setOrder: PropTypes.any,
    setWidth: PropTypes.any,
    withModuleSelect: PropTypes.bool,
    allowLock: PropTypes.bool,
};
export default ReportWindowColumnsContainer;
